import React, { useRef, forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import "./ErrorDialog.css";

const ConfirmDialog = forwardRef(function Dialogue(props, ref) {
  const dialogRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openDialog() {
      dialogRef.current.showModal();
    },
    closeDialog() {
      dialogRef.current.close();
    },
  }));

  const dialogContent = (
    <dialog ref={dialogRef} className="custom-dialog">
      <h2>{props.error ? props.error : "Something went wrong!"}</h2>
      <p>{props.message ? props.message : "Please try again later."}</p>
      <form method="dialog" className="buttonsGroup">
        <button
          className="close-button"
          onClick={() => {
            dialogRef.current.close();
            props?.setState(false);
          }}
        >
          Close
        </button>

        <button
          className="close-button"
          onClick={() => {
            dialogRef.current.close();
            props?.callFunction();
          }}
        >
          Yes
        </button>
      </form>
    </dialog>
  );

  return ReactDOM.createPortal(dialogContent, document.getElementById("modal"));
});

export default ConfirmDialog;
